import ajax from './base';
import socialAjaxmg from './socialmg';

/**
 * 查询活动是否进行中
 * @param {*} { activityCode: , }
 */
const checkLotteryActivity = (data) => ajax('/activityMp/1.0/checkLotteryActivity', data);

/**
 * 查询是否满足活动资格
 * @param {*} {token: ,activityCode: , brandCode:}
 */
const isVehicleOwner = (data) => ajax('/activityMp/1.0/isVehicleOwner', data);
/**
 * 抽奖接口
 * @param {*} {token: ,activityCode: , brandCode: ,adcode ,netEaseToken }
 */
const drawLottery = (data) => ajax('/activityMp/1.0/drawLottery', data);

/**
 * 查询活动是否进行中
 * @param {*} { activityCode: , }
 */
const selectUserPointsV2 = (data) => ajax('/app-mp/uais/1.0/selectUserPointsV2', data);

/**
 * 查询用户是否已经中奖
 * @param {*} { activityCode: , }
 */
const isWinner = (data) => ajax('/app-mp/activityMp/1.0/isWinner', data);

/**
 * 获取用户分享背景图
 * @param {*} { activityCode: , }
 */
const getPhotoList = (data) => ajax('/activityMp/1.0/photoList', data);

/**
 * 获取活动信息
 * @param {*} { activityCode: , }    app-mp/activityMp/1.0/getActivityH5Conf
 */
const getActivityH5Conf = (data) => ajax('/activityMp/1.0/getActivityH5Conf', data);

/**
 * 短信验证码
 * @param {*} { activityCode: , }
 */
const getVerifyCode = (data) => ajax('/uais/1.1/verifyCode2MobileWithRoeweV2?brandcode=2', data);

/**
 * 登录注册
 * @param {*} { activityCode: , }
 */
const loginForActivities = (data) => ajax('/uais/1.0/loginForActivities', data);
// const loginForActivities = (data) => ajax('/activityMp/1.0/loginForActivities', data);
/**
 * 获取年度数据
 * @param { token: String }
 */
export const queryAccountYearBillByCondition = (data) => ajax('/activityMp/1.0/queryAccountYearBillByCondition', data);
// 获取社区活动列表
export const saicActivityAppList = () => socialAjaxmg('/activity/saicActivity/app/list', {
  data: {
    page: 1,
    limit: 100,
    containArticle: 1,
  },
  method: 'post'
});

export default {
  checkLotteryActivity,
  isVehicleOwner,
  drawLottery,
  selectUserPointsV2,
  isWinner,
  getPhotoList,
  getActivityH5Conf,
  getVerifyCode,
  loginForActivities,
  queryAccountYearBillByCondition,
};
